import { Avatar, Tooltip } from 'antd';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';

const HEADER_HEIGHT = 62;

export const HeaderContent = styled.div<{ private?: boolean }>`
  display: flex;
  padding: var(--spacing-03) var(--spacing-05) var(--spacing-03)
    var(--spacing-06);
  border-bottom: 1px solid var(--gray-10);
  align-items: center;
  max-height: '${HEADER_HEIGHT}px';
  justify-content: space-between;
  background: ${(props) =>
    props.private ? 'var(--private-02)' : 'var(--white-100)'};
`;

export const UnreadMessageMarker = styled.div`
  ${BodyShort01};
  padding: var(--spacing-02) var(--spacing-06);
  color: var(--magenta-60);
  font-style: italic;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-05);
  > p {
    flex-shrink: 0;
    margin-bottom: var(--spacing-01);
    padding: 0 var(--spacing-04);
  }
`;

export const UnreadMessageMarkerLine = styled.span<{ block?: boolean }>`
  height: 1px;
  flex-basis: ${(props) => (props.block ? '100%' : '30px')};
  background-color: var(--magenta-60);
`;

export const SeenbyMessage = styled.div`
  color: var(--coolest-gray-10);
  font-size: var(--font-size-sm);
`;

export const HeaderContentPart = styled.div`
  display: flex;
  align-items: center;
`;

export const ConversationHeader = styled.div<{ private: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  padding: var(--spacing-02) 0;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const ChannelName = styled.p`
  font-weight: var(--font-weight-bold);
  margin-bottom: 0;
`;

export const ChannelNameDescriptionWrapper = styled.div`
  flex-grow: 1;
`;

export const ChannelDescription = styled.small`
  .ant-typography {
    color: var(--gray-60);
  }
`;

export const ConvPaneWrapper = styled.div<{ isUserMemberOfChannel: boolean }>`
  height: calc(100% - ${HEADER_HEIGHT}px);
  flex: 1;
  .project-conversation-comment-box {
    border: 1px solid var(--gray-20);
    margin: var(--spacing-06);
    margin-top: 0;
  }
  .ant-comment-inner .ant-comment-avatar {
    width: 56px;
  }
  /* Hide reply buttons in non-member project conversations */
  [data-convpane-reply-btn] {
    display: ${(props) => (props.isUserMemberOfChannel ? 'block' : 'none')};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Seenby = styled(Tooltip)`
  display: flex;
`;

export const RemainingMembers = styled(Avatar)`
  color: var(--white-100);
`;

export const UserItem = styled.p`
  margin-bottom: 0;
`;
